export default __webpack_public_path__ + "static/media/next-not-clicked.62ca40d3.svg";